import { toDateReadable } from '@gov-nx/utils/common';

export const ProfileROSTileDate = ({
	label,
	date,
}: {
	label: string;
	date: string | undefined;
}) => {
	if (!date) return null;

	return (
		<div className="flex items-center gap-1">
			<span className="inline-block mr-1! text-(--text-tertiary)">{label}</span>
			<strong>{toDateReadable(date)}</strong>
		</div>
	);
};
